// Gotham FC BOPIS — team crest lookup.
//
// Maps a `gotham_schedule.opponent` string (as scraped from Gotham's schedule
// page) to a crest image under /images/team-badges/. Coverage is current
// NWSL clubs; anything unmapped (international friendlies, preseason
// opponents, academy sides, a club that changes its name before this map is
// updated) falls back to a neutral generic crest — see badgeForOpponent().
//
// Source/license per file: docs/gotham-bopis-team-badges-sources.md.
// This is an internal, login-gated ops tool (not a public storefront), used
// only to identify which club Gotham is playing — not for merchandising.

const GOTHAM_CREST = '/images/team-badges/gotham-fc.svg';
const GENERIC_CREST = '/images/team-badges/generic-club.svg';

// Exact match on the schedule's `opponent` text (case-insensitive).
const NWSL_CRESTS = {
  'angel city fc':            '/images/team-badges/angel-city-fc.svg',
  'bay fc':                   '/images/team-badges/bay-fc.svg',
  'boston legacy fc':         '/images/team-badges/boston-legacy-fc.svg',
  'chicago stars':            '/images/team-badges/chicago-stars-fc.svg',
  'chicago stars fc':         '/images/team-badges/chicago-stars-fc.svg',
  'denver summit fc':         '/images/team-badges/denver-summit-fc.png',
  'houston dash':             '/images/team-badges/houston-dash.svg',
  'kansas city current':      '/images/team-badges/kansas-city-current.svg',
  'nc courage':                '/images/team-badges/nc-courage.svg',
  'north carolina courage':   '/images/team-badges/nc-courage.svg',
  'orlando pride':            '/images/team-badges/orlando-pride.svg',
  'portland thorns':          '/images/team-badges/portland-thorns.svg',
  'portland thorns fc':       '/images/team-badges/portland-thorns.svg',
  'racing louisville fc':     '/images/team-badges/racing-louisville-fc.svg',
  'san diego wave fc':        '/images/team-badges/san-diego-wave-fc.svg',
  'seattle reign fc':         '/images/team-badges/seattle-reign-fc.svg',
  'utah royals fc':           '/images/team-badges/utah-royals-fc.svg',
  'vancouver rise fc':        '/images/team-badges/vancouver-rise-fc.svg',
  'vancouver rise fc academy':'/images/team-badges/vancouver-rise-fc.svg',
  'washington spirit':        '/images/team-badges/washington-spirit.svg',
  'gotham fc':                GOTHAM_CREST,
};

export function gothamCrest() {
  return GOTHAM_CREST;
}

export function badgeForOpponent(opponent) {
  if (!opponent) return GENERIC_CREST;
  return NWSL_CRESTS[opponent.trim().toLowerCase()] || GENERIC_CREST;
}

export { GENERIC_CREST };
